/** Internal app routes that are built from data rather than hardcoded. */
export const ROUTES = {
  /**
   * Booking interstitial. The reserve buttons navigate here instead of
   * resolving the origin URL inline — a `window.open()` that happens after an
   * `await` is treated as a popup and blocked by the browser.
   *
   * `offerId`/`accommodationId` resolve the origin URL; the rest lets the page
   * re-fetch the stay summary server-side so the URL stays short.
   */
  BOOKING_REDIRECT: ({
    offerId,
    accommodationId,
    originName,
    originLogo,
    stateCity,
    slug,
    checkIn,
    checkOut,
    capacity,
  }: {
    offerId?: string;
    accommodationId?: string;
    originName?: string;
    originLogo?: string | null;
    stateCity?: string;
    slug?: string;
    checkIn?: string;
    checkOut?: string;
    capacity?: number;
  }) => {
    const params = new URLSearchParams();
    if (offerId) params.set("offer", offerId);
    if (accommodationId) params.set("accommodation", accommodationId);
    if (originName) params.set("origin", originName);
    if (originLogo) params.set("originLogo", originLogo);
    if (stateCity) params.set("city", stateCity);
    if (slug) params.set("slug", slug);
    if (checkIn) params.set("checkIn", checkIn);
    if (checkOut) params.set("checkOut", checkOut);
    if (capacity) params.set("capacity", String(capacity));

    return `/redirect?${params.toString()}`;
  },
} as const;
